/**
 * RagApiClient -- Calls n8n RAG webhooks for ingest and query.
 * Uses n8nBase from AppConfig (not the panel API proxy).
 *
 * @module infrastructure/api/RagApiClient
 */

import { AppConfig } from '../../config.js';

const TIMEOUT = 30_000;

async function ragFetch(path, body) {
  const url = `${AppConfig.n8nBase}/webhook/${path}`;
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), TIMEOUT);

  try {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      signal: controller.signal,
      body: JSON.stringify(body)
    });
    clearTimeout(timer);
    if (!res.ok) throw new Error(`n8n ${res.status}`);
    const data = await res.json();
    return { ok: true, data };
  } catch (err) {
    clearTimeout(timer);
    return { ok: false, error: err.message };
  }
}

export const RagApiClient = {
  async ingestText({ doc_id, title, content, collection = 'public', metadata = {} }) {
    return ragFetch('rag/ingest_text', { doc_id, title, content, collection, metadata });
  },

  async query({ question, topK = 5, collection = 'nexo_public' }) {
    return ragFetch('rag/query', { question, topK, collection });
  },

  async listDocuments() {
    return ragFetch('rag/documents', {});
  },

  async deleteDocument(doc_id) {
    return ragFetch('rag/delete', { doc_id });
  },

  async enrichMetadata(doc_id, title) {
    return ragFetch('rag/enrich', { doc_id, title });
  },

  /** Elimina vectores huerfanos (sin metadata.fileName) directamente en la BD RAG */
  async cleanupOrphans() {
    return ragFetch('rag/cleanup-orphans', {});
  }
};
